









import { Component, Prop, Vue } from 'vue-property-decorator';
import { RawLocation } from 'vue-router';

@Component({})
export default class RouterLinkButton extends Vue {
  @Prop()
  public label!: string;

  @Prop({ required: true })
  public to!: RawLocation

  public navigate() {
    this.$emit('navigate');
  }
}
